import React from 'react';
// import classNames from 'classnames';

interface Props {
  version?: string;
}

export const Footer = (props: Props) => {
  const { version } = props;

  return (
    <footer className="Footer">{version && <p className="Footer-version">Version: {version}</p>}</footer>
  );
};
